module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/212.c7b7f6ff.png";